/* eslint-disable react/prop-types */
import axios from 'axios';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Container } from 'reactstrap';

import { queryFirst } from 'helpers/QueryHelper';
import { setLoggedInUser } from 'modules/Login/actions';

export default function SSO({ history }) {
  // Hooks
  const { userId, bookId } = useParams();
  const dispatch = useDispatch();

  // GET USER
  React.useEffect(() => {
    let bookUrl = 'https://sachso.edu.vn';

    if (bookId === '417') {
      // Lớp 1 - Student Book
      bookUrl = `https://faf1.sachso.edu.vn/userid/${userId}/bookid/${bookId}`;
    } else if (bookId === '10899') {
      // Lớp 1 - Work Book
      bookUrl = `https://faf1-wb.sachso.edu.vn/userid/${userId}/bookid/${bookId}`;
    } else if (bookId === '10765') {
      // Lớp 2 - Student Book
      bookUrl = `https://faf2.sachso.edu.vn/userid/${userId}/bookid/${bookId}`;
    } else if (bookId === '10811') {
      // Lớp 2 - Work Book
      bookUrl = `https://faf2-wb.sachso.edu.vn/userid/${userId}/bookid/${bookId}`;
    } else if (bookId === '10984') {
      // Lớp 3 - Student Book (Phiên bản từ 3 - 5)
      bookUrl = `https://faf3-sb-v2.sachso.edu.vn/userid/${userId}/bookid/${bookId}`;
    } else if (bookId === '11302') {
      // Lớp 3 - Work Book (Phiên bản từ 3 - 5)
      bookUrl = `https://faf3-wb-v2.sachso.edu.vn/userid/${userId}/bookid/${bookId}`;
    } else if (bookId === '11306') {
      // Lớp 4 - Student Book - (Phiên bản từ 1 - 5)
      bookUrl = `https://faf4.sachso.edu.vn/userid/${userId}/bookid/${bookId}`;
    } else if (bookId === '11307') {
      // Lớp 4 - Work Book - (Phiên bản từ 1 - 5)
      bookUrl = `https://faf4-wb.sachso.edu.vn/userid/${userId}/bookid/${bookId}`;
    } else if (bookId === '11308') {
      // Lớp 5 - Student Book - (Phiên bản từ 1 - 5)
      bookUrl = `https://faf5.sachso.edu.vn/userid/${userId}/bookid/${bookId}`;
    } else if (bookId === '11309') {
      // Lớp 5 - Work Book - (Phiên bản từ 1 - 5)
      bookUrl = `https://faf5-wb.sachso.edu.vn/userid/${userId}/bookid/${bookId}`;
    } else if (bookId === '10794') {
      // Lớp 6 - Student Book
      bookUrl = `https://fp6.sachso.edu.vn/userid/${userId}/bookid/${bookId}`;
    } else if (bookId === '10898') {
      // Lớp 6 - Work Book
      bookUrl = `https://fp6-wb.sachso.edu.vn/userid/${userId}/bookid/${bookId}`;
    } else if (bookId === '11019') {
      // Lớp 7 - Student Book
      bookUrl = `https://fp7-sb.sachso.edu.vn/userid/${userId}/bookid/${bookId}`;
    } else if (bookId === '11304') {
      // Lớp 7 - Work Book
      bookUrl = `https://fp7-wb.sachso.edu.vn/userid/${userId}/bookid/${bookId}`;
    } else if (bookId === '11102') {
      // Lớp 10 - Student Book
      bookUrl = `https://fg10-sb.sachso.edu.vn/userid/${userId}/bookid/${bookId}`;
    } else if (bookId === '11315') {
      // Lớp 10 - Work Book
      bookUrl = `https://fg10-wb.sachso.edu.vn/userid/${userId}/bookid/${bookId}`;
    } else if (bookId === '11310') {
      // Lớp 4 - Student Book (Phiên bản từ 3 - 5)
      bookUrl = `https://faf4-sb-v2.sachso.edu.vn/userid/${userId}/bookid/${bookId}`;
    } else if (bookId === '11313') {
      // Lớp 4 - Work Book (Phiên bản từ 3 - 5)
      bookUrl = `https://faf4-wb-v2.sachso.edu.vn/userid/${userId}/bookid/${bookId}`;
    } else if (bookId === '11312') {
      // Lớp 5 - Student Book (Phiên bản từ 3 - 5)
      bookUrl = `https://faf5-sb-v2.sachso.edu.vn/userid/${userId}/bookid/${bookId}`;
    } else if (bookId === '11314') {
      // Lớp 5 - Work Book (Phiên bản từ 3 - 5)
      bookUrl = `https://faf5-wb-v2.sachso.edu.vn/userid/${userId}/bookid/${bookId}`;
    } else if (bookId === '11467') {
      // Lớp 8 - Student Book (Phiên bản 2023)
      bookUrl = `https://fp8-sb-2023.sachso.edu.vn/userid/${userId}/bookid/${bookId}`;
    } else if (bookId === '11468') {
      // Lớp 4 - Student Book (Phiên bản 2023)
      bookUrl = `https://faf4-sb-2023.sachso.edu.vn/userid/${userId}/bookid/${bookId}`;
    } else if (bookId === '11328') {
      // Sách MN 1
      bookUrl = `https://mn1.sachso.edu.vn/userid/${userId}/bookid/${bookId}`;
    } else if (bookId === '11329') {
      // Sách MN 2
      bookUrl = `https://mn2.sachso.edu.vn/userid/${userId}/bookid/${bookId}`;
    } else if (bookId === '11330') {
      // Sách MN 3
      bookUrl = `https://mn3.sachso.edu.vn/userid/${userId}/bookid/${bookId}`;
    } else if (bookId === '11510') {
      // Sách 4 WB 2023
      bookUrl = `https://faf4-wb-2023.sachso.edu.vn/userid/${userId}/bookid/${bookId}`;
    } else if (bookId === '11540') {
      // Sách 8 WB 2023
      bookUrl = `https://fp8-wb-2023.sachso.edu.vn/userid/${userId}/bookid/${bookId}`;
    } else if (bookId === '11567') {
      // Sách 11 WB 2023
      bookUrl = `https://fp11-wb-2023.sachso.edu.vn/userid/${userId}/bookid/${bookId}`;
    }
    window.location.href = bookUrl;

    const fetch = async () => {
      const config = {
        method: 'get',
        url: `https://apihanhtrangso.nxbgd.vn/api/SachSo/getUserById?userId=${userId}`,
        headers: {
          ClientId: 'SachSo_6JY98PxbiZ9',
          ClientSecret: '3b0a515fgRjigcHJoSrSVWud9ZV0e4341a387d076de2b54d509Io6UiEq0MrkwRSuF8mTrpYw',
        },
      };

      const userResponse = await axios(config);
      const user = userResponse.data.data;

      // console.log(user);

      // Add user to AMES247
      const registeredUser = await queryFirst('p_SACHSO_Users_Register', {
        email: user.email,
        fullName: `${user.firstName} ${user.lastName}`,
        roleId: user.roleCode === 'PUPIL' ? 1 : 2,
      });

      const finalUser = { ...registeredUser, userRoles: [] };

      if (user.roleCode === 'PUPIL') {
        finalUser.role = 'student';
        finalUser.userRoles.push('student');
      } else {
        finalUser.role = 'teacher';
        finalUser.userRoles.push('teacher');
      }

      // console.log(finalUser);

      dispatch(setLoggedInUser(finalUser));

      // history.push('/lms/activated-books/');

      // config.url = 'https://apihanhtrangso.nxbgd.vn/api/SachSo/getBookById?bookId=' + bookId;
      // let bookResponse = await axios(config);
      // const book = bookResponse.data.data;

      if (finalUser) {
        let bookUrl = 'https://sachso.edu.vn';

        if (bookId === '417') {
          // Lớp 1 - Student Book
          bookUrl = `https://faf1.sachso.edu.vn/userid/${finalUser.rowId}/bookid/${bookId}`;
        } else if (bookId === '10899') {
          // Lớp 1 - Work Book
          bookUrl = `https://faf1-wb.sachso.edu.vn/userid/${finalUser.rowId}/bookid/${bookId}`;
        } else if (bookId === '10765') {
          // Lớp 2 - Student Book
          bookUrl = `https://faf2.sachso.edu.vn/userid/${finalUser.rowId}/bookid/${bookId}`;
        } else if (bookId === '10811') {
          // Lớp 2 - Work Book
          bookUrl = `https://faf2-wb.sachso.edu.vn/userid/${finalUser.rowId}/bookid/${bookId}`;
        } else if (bookId === '10984') {
          // Lớp 3 - Student Book (Phiên bản từ 3 - 5)
          bookUrl = `https://faf3-sb-v2.sachso.edu.vn/userid/${finalUser.rowId}/bookid/${bookId}`;
        } else if (bookId === '11302') {
          // Lớp 3 - Work Book (Phiên bản từ 3 - 5)
          bookUrl = `https://faf3-wb-v2.sachso.edu.vn/userid/${finalUser.rowId}/bookid/${bookId}`;
        } else if (bookId === '11306') {
          // Lớp 4 - Student Book - (Phiên bản từ 1 - 5)
          bookUrl = `https://faf4.sachso.edu.vn/userid/${finalUser.rowId}/bookid/${bookId}`;
        } else if (bookId === '11307') {
          // Lớp 4 - Work Book - (Phiên bản từ 1 - 5)
          bookUrl = `https://faf4-wb.sachso.edu.vn/userid/${finalUser.rowId}/bookid/${bookId}`;
        } else if (bookId === '11308') {
          // Lớp 5 - Student Book - (Phiên bản từ 1 - 5)
          bookUrl = `https://faf5.sachso.edu.vn/userid/${finalUser.rowId}/bookid/${bookId}`;
        } else if (bookId === '11309') {
          // Lớp 5 - Work Book - (Phiên bản từ 1 - 5)
          bookUrl = `https://faf5-wb.sachso.edu.vn/userid/${finalUser.rowId}/bookid/${bookId}`;
        } else if (bookId === '10794') {
          // Lớp 6 - Student Book
          bookUrl = `https://fp6.sachso.edu.vn/userid/${finalUser.rowId}/bookid/${bookId}`;
        } else if (bookId === '10898') {
          // Lớp 6 - Work Book
          bookUrl = `https://fp6-wb.sachso.edu.vn/userid/${finalUser.rowId}/bookid/${bookId}`;
        } else if (bookId === '11019') {
          // Lớp 7 - Student Book
          bookUrl = `https://fp7-sb.sachso.edu.vn/userid/${finalUser.rowId}/bookid/${bookId}`;
        } else if (bookId === '11304') {
          // Lớp 7 - Work Book
          bookUrl = `https://fp7-wb.sachso.edu.vn/userid/${finalUser.rowId}/bookid/${bookId}`;
        } else if (bookId === '11102') {
          // Lớp 10 - Student Book
          bookUrl = `https://fg10-sb.sachso.edu.vn/userid/${finalUser.rowId}/bookid/${bookId}`;
        } else if (bookId === '11315') {
          // Lớp 10 - Work Book
          bookUrl = `https://fg10-wb.sachso.edu.vn/userid/${finalUser.rowId}/bookid/${bookId}`;
        } else if (bookId === '11310') {
          // Lớp 4 - Student Book (Phiên bản từ 3 - 5)
          bookUrl = `https://faf4-sb-v2.sachso.edu.vn/userid/${finalUser.rowId}/bookid/${bookId}`;
        } else if (bookId === '11313') {
          // Lớp 4 - Work Book (Phiên bản từ 3 - 5)
          bookUrl = `https://faf4-wb-v2.sachso.edu.vn/userid/${finalUser.rowId}/bookid/${bookId}`;
        } else if (bookId === '11312') {
          // Lớp 5 - Student Book (Phiên bản từ 3 - 5)
          bookUrl = `https://faf5-sb-v2.sachso.edu.vn/userid/${finalUser.rowId}/bookid/${bookId}`;
        } else if (bookId === '11314') {
          // Lớp 5 - Work Book (Phiên bản từ 3 - 5)
          bookUrl = `https://faf5-wb-v2.sachso.edu.vn/userid/${finalUser.rowId}/bookid/${bookId}`;
        } else if (bookId === '11467') {
          // Lớp 8 - Student Book (Phiên bản 2023)
          bookUrl = `https://fp8-sb-2023.sachso.edu.vn/userid/${finalUser.rowId}/bookid/${bookId}`;
        } else if (bookId === '11468') {
          // Lớp 4 - Student Book (Phiên bản 2023)
          bookUrl = `https://faf4-sb-2023.sachso.edu.vn/userid/${finalUser.rowId}/bookid/${bookId}`;
        } else if (bookId === '11328') {
          // Sách MN 1
          bookUrl = `https://mn1.sachso.edu.vn/userid/${finalUser.rowId}/bookid/${bookId}`;
        } else if (bookId === '11329') {
          // Sách MN 2
          bookUrl = `https://mn2.sachso.edu.vn/userid/${finalUser.rowId}/bookid/${bookId}`;
        } else if (bookId === '11330') {
          // Sách MN 3
          bookUrl = `https://mn3.sachso.edu.vn/userid/${finalUser.rowId}/bookid/${bookId}`;
        } else if (bookId === '11510') {
          // Sách 4 WB 2023
          bookUrl = `https://faf4-wb-2023.sachso.edu.vn/userid/${finalUser.rowId}/bookid/${bookId}`;
        } else if (bookId === '11540') {
          // Sách 8 WB 2023
          bookUrl = `https://fp8-wb-2023.sachso.edu.vn/userid/${finalUser.rowId}/bookid/${bookId}`;
        } else if (bookId === '11567') {
          // Sách 11 WB 2023
          bookUrl = `https://fp11-wb-2023.sachso.edu.vn/userid/${finalUser.rowId}/bookid/${bookId}`;
        }
        // else if (bookId === '') {
        //   // Lớp 3 - Student Book (Phiên bản từ 1 - 5)
        //   bookUrl = `https://faf3.sachso.edu.vn/userid/${finalUser.rowId}/bookid/${bookId}`;
        // } else if (bookId === '') {
        //   // Lớp 3 - Work Book (Phiên bản từ 1 - 5)
        //   bookUrl = `https://faf3-wb.sachso.edu.vn/userid/${finalUser.rowId}/bookid/${bookId}`;
        // }

        // console.log(bookUrl);
        window.location.href = bookUrl;
      }
      // console.log('USE', user);
      // console.log('BOOK', book);
    };

    // fetch();
  }, [userId, bookId, dispatch, history]);

  return (
    <React.Fragment>
      <Container>
        <h1>SSO</h1>
        <h2>Loading ...</h2>
      </Container>
    </React.Fragment>
  );
}
